/*eslint-disable*/
import store from '@/store';
import { options } from 'less';
import { key } from 'localforage';
const tenantCode = store.getters.currentTenant.tenantCode;
// 表单配置信息
export const collapse = [
    {
        title: '数据删除信息',
        ref: 'qingshiForm',
        formName: 'qingshiInfo',
        col: 4,
        labelWidth: '80px',
        visible: true,
        formList: [
            {
                label: '申请编码',
                prop: 'renewalGroupCode',
                value: 'renewalGroupCode',
                type: 'custom',
                span: 23,
            },
            {
                label: '相关描述',
                prop: 'renewalRemark',
                value: 'renewalRemark',
                // type: 'custom',
                // span: 24,
                sourceType: 'input',
                inputType: 'textarea',
                type: 'input',
                span: 23,
                // maxlength: 1024,
                rows: 10,
                showWordLimit: true,
                rule: [{ required: true, message: '相关描述不能为空', trigger: 'change' }],
                disabled: false
            },
            {
                label: '附件',
                prop: 'relatedFiles',
                value: 'relatedFiles',
                type: 'custom',
                span: 23,
                rule: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (rule.required && !value.length) {
                                callback(new Error('相关附件不能为空'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
            },
            {
                label: '',
                prop: 'registractionList',
                value: 'registractionList',
                type: 'custom',
                span: 24,
            },
        ]
    },
];
